import React from 'react';

export function AdvanceBadge({ status }) {
  const key = String(status || 'pending').toLowerCase();
  if (key === 'pay on arrival') {
    return <span className="status-badge" style={{ background: 'rgba(245,166,35,.18)', color: '#f5a623' }}>Pay on Arrival</span>;
  }
  if (key === 'advance waived (regular guest)') {
    return <span className="status-badge" style={{ background: 'rgba(155,92,255,.16)', color: '#9b5cff' }}>Advance Waived (Regular Guest)</span>;
  }
  const cls = key === 'paid' ? 's-new' : key === 'refunded' ? 's-modified' : 's-inquiry';
  return <span className={`status-badge ${cls}`}>{status || 'Pending'}</span>;
}
